import {
  TrackingPageTypeWithId,
  TrackingPromotionCreative,
} from '@aboutyou/legacy-tracking-sdk'
import { ElementTrackingContextProvider } from 'helpers/tracking/ElementTrackingContext'
import { PromotionImpression } from 'helpers/tracking/trackerComponents/ElementTracker'
import React, { FC } from 'react'
import Brand from 'store/entities/Brands/Brand.store'
import styled from 'styled-components'

const StyledPromotionImpression = styled(PromotionImpression)`
  width: 100%;
  max-width: 100%;
`

const BrandPromotionTracker: FC<
  React.PropsWithChildren<{
    brand: Brand
  }>
> = ({ children, brand }) => (
  <ElementTrackingContextProvider>
    <StyledPromotionImpression
      type={TrackingPageTypeWithId.Brand}
      id={brand.id}
      name={brand.name}
      url={brand.url}
      source={TrackingPromotionCreative.BrandReco}
      useIdForDestination
    >
      {children}
    </StyledPromotionImpression>
  </ElementTrackingContextProvider>
)

export default BrandPromotionTracker
